<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{ $route.meta.title }}</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>审单考核管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <template slot="header">搜索</template>
      <el-form :model="search"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()"
               ref="searchForm">
        <div class="re-el-form__flex">
          <el-form-item label="订单ID" prop="orderid">
            <el-input v-model="search.orderid"
                      placeholder="请输入订单ID"
                      clearable
                      class="width-max">
            </el-input>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
          <el-button @click="resetForm('searchForm')"
                     size="mini">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">

        <el-table-column prop="id"
                         label="ID"
                         width="80">
        </el-table-column>
        <el-table-column prop="orderid"
                         label="订单ID"
                         width="120"
                         align="center">
        </el-table-column>
        <el-table-column prop="wrong_questions"
                         label="错题题号"
                         min-width="200">
          <template slot-scope="scope">
            <template v-if="scope.row.wrong_questions && scope.row.wrong_questions.length">
              <el-tag v-for="(q, idx) in scope.row.wrong_questions"
                      :key="idx"
                      size="small"
                      type="warning"
                      class="question-tag">Q{{ q }}</el-tag>
            </template>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="remarks"
                         label="备注"
                         min-width="150"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="评审时间"
                         width="180"
                         align="center">
        </el-table-column>
        <el-table-column prop="created_by"
                         label="评审人"
                         width="120"
                         align="center">
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  name: 'KeyinExceptionFeedback',
  mixins: [table],
  data () {
    return {
      search: {
        orderid: null,
      },
      searchFieldType: {
        orderid: Number,
      },
      table: [],
    }
  },
  methods: {
    /**
     * 获得表格数据（接口返回 list + total，转换为 mixin 需要的 data.data + total）
     */
    getTableData (params) {
      return request.page('getQueryKeyin', params)
    },
    /**
     * 重置表单
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.onSearch()
    },
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
.question-tag {
  margin-right: 4px;
  margin-bottom: 4px;
}
.text-muted {
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review-target-management/pages/KeyinExceptionFeedback.vue